import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { environment } from '@environment/environment';
import { TreeService } from '@shared/services';
import { ResourcesService } from '@shared/services/resources.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { first, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-zone-details-popup',
  templateUrl: './zone-details-popup.component.html',
  styleUrls: ['./zone-details-popup.component.scss']
})
export class ZoneDetailsPopupComponent implements OnInit {

  constructor(private modalService: BsModalService,
     private _treeService: TreeService,
        private _resourceService: ResourcesService
    
  ) { }

  ngOnInit(): void {
  }
    @ViewChild('buildingInfoForm', { static: true }) formModal: TemplateRef<any>;
      private _unsubscribeAll$ = new Subject<void>();
  
  currentZone : any;
  parentLocationname : any;
     openModal(locId) : void {
        //debugger
        this.getLocationById(locId);
        this.getLocationLayoutDetails(locId)
      const configs = {
              keyboard: false,
              ignoreBackdropClick: true,
              class: ' modal-lg modal-primary  ModelPopUpLayoutFilterPopUps commenModel  fadeInCenter',
              animated: false
          };
          this.modalRef = this.modalService.show(this.formModal, configs);
        
      }
       modalRef: BsModalRef | null;

        closeZoneDetailsModal() {
        this.modalRef.hide();
        this.currentZone = null;
        this.parentLocationname = null;
    }

    getLocationById(locId){
      //debugger
            this._treeService
                  .Getlocationbyid(locId)
                  .pipe(takeUntil(this._unsubscribeAll$), first())
                  .subscribe(
                    (result) => {
                      this.currentZone = result.data;
                    //  console.log('location load', this.currentZone);
                    //console.log("current zone ", this.currentZone);

                    },
                    (error) => {
                      console.error('Error fetching contact:', error);
                    }
                  );
    
          }

          mapBackGround : any;

           getLocationLayoutDetails(id) {
              this._resourceService
                .GetLocationLayoutDetails(id)
                .pipe(takeUntil(this._unsubscribeAll$), first())
                .subscribe((result) => {
                  
                  //console.log("get location layout details", result.data);
                  this.mapBackGround = result.data.backGroundFileData;
                });
            }
          

       ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }
  

}
